import config from 'constants/apiConfig';
import axios from 'axios';

import { toast } from 'react-toastify';
import { endLoading, startLoading } from 'reducers/loading/loading.action';

import parseErrorMessage from 'utils/parseErrorMessage';

import {
  GENERATE_TEAMS_SITE_REQUEST,
  GENERATE_TEAMS_SITE_SUCCESS,
  GENERATE_TEAMS_SITE_ERROR,
  UPLOAD_FILE_TO_TEAMS_REQUEST,
  UPLOAD_FILE_TO_TEAMS_SUCCESS,
  UPLOAD_FILE_TO_TEAMS_ERROR,
  GET_TEAMS_TEMPLATE_SUCCESS,
  UPDATE_TEAMS_TENANT_ID,
  CHECK_TEAMS,
  CHECK_TEAMS_STATUS_SUCCESS,
} from 'constants/teams-action-types';

import { toastConfig, noAutoClose } from 'assets/data/config';
import {
  removeSelfFromIncident,
  removeUserFromIncidentByAdmin,
} from './incidentActions';
import { changeSelectedWorkSpaceStatus } from 'PREPAREsrc/store/workspaces/workspaces.action';

export function generateTeamsSiteRequest(incident_id) {
  return {
    type: GENERATE_TEAMS_SITE_REQUEST,
    payload: incident_id,
  };
}

function generateTeamsSiteSuccess() {
  return {
    type: GENERATE_TEAMS_SITE_SUCCESS,
  };
}
export function updateTeamsTenants(tenant_Id) {
  return {
    type: UPDATE_TEAMS_TENANT_ID,
    payload: tenant_Id,
  };
}

function getTeamTemplateSuccess(templateList) {
  return {
    type: GET_TEAMS_TEMPLATE_SUCCESS,
    payload: templateList,
  };
}

function incrementTeamCheckCounter(incidentId, count, timeout) {
  return {
    type: CHECK_TEAMS,
    payload: { incidentId, count, timeout },
  };
}

function generateTeamsSiteError(error) {
  const errorMessage =
    'generateTeamsSiteError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: GENERATE_TEAMS_SITE_ERROR,
  };
}

export function getTeamsTemplateError(error) {
  const errorMessage =
    'getTeamsTemplateError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
}

function checkTeamsStatusSuccess(teamsStatusInfo, incidentId) {
  return {
    type: CHECK_TEAMS_STATUS_SUCCESS,
    payload: { teamsStatusInfo, incidentId },
  };
}
export const teamSiteCreationStatuses = {
  UNSTARTED: 'unstarted',
  INPROGRESS: 'inprogress',
  DONE: 'done',
};

export const generateTeamsSite = (incidentId, template, tenantId) => {
  return (dispatch) => {
    dispatch(generateTeamsSiteRequest(incidentId));
    dispatch(
      checkTeamsStatusSuccess(
        {
          teams_id: undefined,
          sharepoint_location: undefined,
          channel_id: undefined,
          tenant_id: tenantId,
          teams_status: teamSiteCreationStatuses.INPROGRESS,
        },
        incidentId
      )
    );
    axios(config.apiGateway.generateTeamSite, {
      method: 'POST',
      data: JSON.stringify({
        incidentId,
        template,
        tenantId,
      }),
    })
      .then(() => {
        toast.success('Creating Teams Site Started', toastConfig);
        dispatch(checkTeamsStatus(incidentId, 'incident'));
      })
      .catch((error) => {
        dispatch(generateTeamsSiteError(error));
      });
  };
};

export const generateWorkspace = (
  workspace_id,
  template,
  tenantId,
  user_id
) => {
  return (dispatch) => {
    axios(config.apiGateway.generateTeamSite, {
      method: 'POST',
      data: JSON.stringify({
        workspace_id,
        template,
        tenantId: tenantId,
        user_id,
      }),
    })
      .then((response) => {
        toast.success('Creating Teams Site Started', toastConfig);
        dispatch(checkTeamsStatus(workspace_id, 'workspace'));
        return response;
      })
      .catch((error) => {
        dispatch(generateTeamsSiteError(error));
      });
  };
};

export const checkTeamsStatus = (id, workspace_type) => {
  return (dispatch, getState) => {
    const { checkTeamCounter } = getState().app;

    // We will only check one incident at a time.
    clearTimeout(checkTeamCounter.timeout);

    axios(config.apiGateway.checkTeamsStatus, {
      method: 'POST',
      data: JSON.stringify({
        id: id,
        workspace_type,
      }),
    })
      .then((response) => {
        const teamsStatusInfo = response?.data;
        const creationStatus = teamsStatusInfo?.creation_status;
        console.log(
          'Checking Team Status',
          teamsStatusInfo,
          creationStatus,
          checkTeamCounter.count
        );

        let timeout;

        if (creationStatus === teamSiteCreationStatuses.INPROGRESS) {
          if (checkTeamCounter.count < 10) {
            timeout = setTimeout(() => {
              dispatch(checkTeamsStatus(id, workspace_type));
            }, 30000);

            dispatch(
              incrementTeamCheckCounter(
                checkTeamCounter.incidentId,
                checkTeamCounter.count + 1,
                timeout
              )
            );
          }
        } else if (creationStatus === teamSiteCreationStatuses.DONE) {
          if (checkTeamCounter.timeout) {
            toast.success('Teams site created successfully', toastConfig);
          }

          clearTimeout(checkTeamCounter.timeout);

          dispatch(
            checkTeamsStatusSuccess(
              {
                ...teamsStatusInfo.info,
                teams_status: teamsStatusInfo.info.teams_status,
              },
              id
            )
          );
          dispatch(generateTeamsSiteSuccess());
          dispatch(changeSelectedWorkSpaceStatus(creationStatus));
        }

        dispatch(checkTeamsStatusSuccess(teamsStatusInfo, id));
      })
      .catch((error) => {
        console.error('Error checking for team status:', error);
      });
  };
};

export const fetchTeamTemplates = (tenantId) => {
  return (dispatch) => {
    dispatch(startLoading());
    return axios(config.apiGateway.teamTemplateIds, {
      method: 'POST',
      data: JSON.stringify({
        tenantId: tenantId,
      }),
    })
      .then((response) => {
        if (
          response.data?.message &&
          response.data.message === 'No template found'
        ) {
          dispatch(endLoading());
          toast.error('No Teams Saved Templates Found', toastConfig);
        }
        if (response?.data && response.data.length > 0) {
          const templateArray = response.data.map((template) => {
            return {
              label: template.name,
              value: template.id,
            };
          });
          dispatch(getTeamTemplateSuccess(templateArray, tenantId));
          dispatch(endLoading());
        }
      })
      .catch((error) => {
        console.log('fetchTeamTemplates error : ', error);
        dispatch(endLoading());
        dispatch(getTeamsTemplateError(error));
      });
  };
};

function uploadFileToTeamsRequest() {
  return {
    type: UPLOAD_FILE_TO_TEAMS_REQUEST,
  };
}

function uploadFileToTeamsSuccess() {
  return {
    type: UPLOAD_FILE_TO_TEAMS_SUCCESS,
  };
}

function uploadFileToTeamsError(error) {
  const errorMessage =
    'uploadFileToTeamsError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: UPLOAD_FILE_TO_TEAMS_ERROR,
  };
}

export const shareFileWithTeams = ({ formName }) => {
  return (dispatch, getState) => {
    dispatch(uploadFileToTeamsRequest());
    const { currentIncident } = getState().app;
    const user = getState().app.user;
    const {
      tenant_id,
      id: incident_id,
      teams_id,
      sharepoint_location,
      channel_id,
      group_guid,
    } = currentIncident || {};

    return axios(config.apiGateway.shareFileWithTeams, {
      method: 'POST',
      data: JSON.stringify({
        file_name: formName,
        tenant_id,
        incident_id,
        teams_id,
        sharepoint_location,
        channel_id,
        group_guid,
        incident: currentIncident,
        user,
      }),
    })
      .then((response) => {
        dispatch(uploadFileToTeamsSuccess());
        if (
          response.data.message ==
          'File uploaded successfully to the channel of the workspace.'
        ) {
          toast.success('File uploaded successfully.', toastConfig);
        }
      })
      .catch((error) => {
        dispatch(uploadFileToTeamsError(error));
      });
  };
};

export const addMemberToTeams = (incident_id, membersEmail) => {
  return (dispatch, getState) => {
    const { userName } = getState().auth.account;
    return axios(config.apiGateway.addMemberToTeams, {
      method: 'POST',
      data: JSON.stringify({
        incident_id,
        userName,
        membersEmail,
      }),
    })
      .then((response) => {
        if (response.data.message === 'Member added to teams Successfully') {
          toast.success(
            'Member is successfully add to Team site.',
            toastConfig
          );
        } else if (response.status === 207) {
          response.data.data.map((failure) => {
            toast.warn(`${failure.email} ${failure.reason}.`, {
              ...toastConfig,
              autoClose: false,
            });
          });
        }
      })
      .catch((error) => {
        console.log('addMemberToTeamSite error', error);
        if (error.response?.data?.data?.length) {
          const data = error.response?.data.data;
          data.map((err) => {
            toast.warn(`${err?.email + ' ' + err.reason}`, {
              ...toastConfig,
              autoClose: false,
            });
          });
        } else {
          toast.error('Something went wrong.', toastConfig);
        }
      });
  };
};

export const RemoveUserFromTeamSite = (
  user,
  incidentId,
  deleteMemberData,
  type
) => {
  return (dispatch) => {
    return axios(config.apiGateway.removeMemberFromTeams, {
      method: 'POST',
      data: JSON.stringify({
        incidentId,
        userEmail: deleteMemberData.email_address,
        type,
      }),
    })
      .then((response) => {
        console.log('Response Data:', response.data);

        const { status, message } = response.data;

        if (status === 204) {
          // Success: Member removed from Teams
          toast.success('The member was removed from the Teams site.', {
            ...toastConfig,
            autoClose: true,
          });

          // Proceed to remove the member in Pratus
          if (user === 'self') {
            dispatch(removeSelfFromIncident(deleteMemberData));
          } else {
            dispatch(removeUserFromIncidentByAdmin(deleteMemberData));
          }
        } else if (status === 400) {
          // Display the specific error message from Azure function
          console.warn('Cannot remove member:', message);
          toast.error(
            message ||
              'Cannot remove member. Resolve the issue in the Teams client and try again.',
            { ...toastConfig, autoClose: false }
          );
          dispatch(endLoading());
          return; // Exit early
        } else if (status === 404) {
          // Informational: Member not found in Teams
          toast.warn(
            message ||
              'The member was not found in Teams. They may have been removed in the Teams UI.',
            { ...toastConfig, autoClose: false }
          );

          // Proceed to remove the member in Pratus
          if (user === 'self') {
            dispatch(removeSelfFromIncident(deleteMemberData));
          } else {
            dispatch(removeUserFromIncidentByAdmin(deleteMemberData));
          }
        } else {
          // Handle other unexpected statuses
          console.error('Unexpected status:', status, message);
          toast.error(
            message ||
              'An unexpected error occurred while removing the member.',
            { ...toastConfig, autoClose: false }
          );
        }
      })
      .catch((error) => {
        console.error('Error in removeMemberToTeamSite:', error);
        toast.error(
          'An error occurred while removing the member. Please try again.',
          { ...toastConfig, autoClose: false }
        );
      });
  };
};

export const RemoveUserFromWorkspaceTeamSite = (
  user,
  incidentId,
  email,
  type
) => {
  return (dispatch) => {
    return axios(config.apiGateway.removeMemberFromTeams, {
      method: 'POST',
      data: JSON.stringify({
        incidentId,
        userEmail: email,
        type,
      }),
    })
      .then((response) => {
        if (response.data.status !== 204) {
          console.log('Error Message is:' + response.data.message);
          dispatch(endLoading());
          if (response.data.status === 404) {
            toast.warn(
              response.data?.message
                ? response.data?.message
                : 'Error Removing Member from the Teams',
              { ...toastConfig, autoClose: false }
            );
          } else {
            toast.error(
              response.data?.message ? response.data?.message : 'Error',
              { ...toastConfig, autoClose: false }
            );
          }
        } else {
          toast.success('The member was removed from the Teams site.', {
            ...toastConfig,
            autoClose: false,
          });
        }
      })
      .catch((error) => {
        console.log('removeMemberToTeamSite error', error);
        dispatch(endLoading());
      });
  };
};

export const storeSsoToken = (aadObjectId, ssoToken) => {
  return () => {
    return axios(config.apiGateway.storeSsoToken, {
      method: 'POST',
      headers: {
        'x-teamsapp': 'true',
        Authorization: `Bearer ${ssoToken}`,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        aadObjectId,
        ssoToken,
      }),
    })
      .then((response) => {
        console.log('SSO token stored successfully.');
        return response;
      })
      .catch((error) => {
        console.error('Error storing SSO token:', error);
      });
  };
};
